/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

(() => {
  const mq = window.matchMedia("(max-width: 47.9275em)");

  const stopAutoplayOnMobile = () => {
    if (!mq.matches) return;

    document.querySelectorAll("media-carousel").forEach((carousel) => {
      // stop right away if it already initialized
      try { carousel.stop?.(); } catch (e) {}

      // also stop as soon as it initializes (covers slow load / delayed init)
      carousel.addEventListener(
        "on:media-carousel:init",
        () => {
          try { carousel.stop?.(); } catch (e) {}
        },
        { once: true }
      );
    });
  };

  document.addEventListener("DOMContentLoaded", stopAutoplayOnMobile);
})();

